<form [formGroup]="editvehform">
    <div class="createride">
        <div style="width:100%">
        <div class="close" (click)="closeDialog()">
            <mat-icon style="cursor:pointer">close</mat-icon>
        </div>
        <div class="crt">Edit Vehicle Type</div></div>
    <div style="width: 90%;">
        <label>Name</label>
        <input class="form-control" placeholder="Enter Name" style="border-radius: 10px;width: 100%;margin-top: 7px;" formControlName="name">           <div *ngIf=" 
        Submitted  && f['name'].invalid
         " class="danger">
                  <div class="error" style="color: red" *ngIf="f['name'].errors && f['name'].errors['required']">
                      *Mandatory Field
                  </div>
              </div>
              <div *ngIf="f['name'].dirty && f['name'].invalid">
                  <div class="error" style="color: red" *ngIf="
    f['name'].errors &&
    f['name'].errors['pattern']">
                      Enter valid name
                  </div>
              </div>
              <div *ngIf="f['name'].dirty && f['name'].invalid">
                <div class="error" style="color: red" *ngIf="f['name'].errors && f['name'].errors?.maxlength">
                    Name cannot be longer than 150 characters
                </div>
            </div>
    </div>
    <div  class="upload"
    style="width: 90%;border: 2px dashed #000;border-radius: 10px;">
    <img [src]=" image1 || '/assets/upload.svg'" class="image"  (click)="imagedata.click()">
    <label class="label">Upload Icon</label>
    <div class="uploadimage">
        <input #imagedata type="file" accept="image/*" (change)="process(imagedata)" style="width: 193px;display:none;">
    <label class="label1"  (click)="imagedata.click()"><a style="color: #013220;cursor: pointer;">Browse</a>&nbsp; from computer</label>
    <!-- <label class="label1">from computer</label> -->
    </div>
    </div>
    <div style="width: 90%;">
        <label>Number of Seats</label>
        <input 
            class="form-control" 
            placeholder="Enter number of seats" 
            style="border-radius: 10px;width: 100%;margin-top: 7px;" 
            formControlName="numberOfSeats" 
            type="number" 
            min="1"
            max="1000">
        <div *ngIf="Submitted && f['numberOfSeats'].invalid" class="danger">
            <div class="error" style="color: red" *ngIf="f['numberOfSeats'].errors?.['required']">
                *Mandatory Field
            </div>
            <div class="error" style="color: red" *ngIf="f['numberOfSeats'].errors?.['pattern']">
                Enter a valid number
            </div>
        </div>
    </div>
    <div *ngIf="
              Submitted && f['image'].invalid
              " class="danger" style="width: 90%;margin-top:-18px">
                                <div class="error" style="color: red" *ngIf="f['image'].errors && f['image'].errors['required']">
                                    *Mandatory Field
                                </div>
                            </div>
    <div><button class="submit" (click)="editvehicle(editvehform.valid)">Submit</button></div>
    
    </div>
    </form>
